import React, { useRef, useEffect } from 'react';

import { TextField as TextFieldDS } from '@BICE_Vida/components';
import { TextFieldT as TextFieldDST } from '@BICE_Vida/components/dist/components/TextField/TextField';

import { breakPointSm } from '../../utils/constants';
import { useScroll } from '../../customHooks';

type TextFieldT = {
  autoFocus?: boolean;
  autoScroll?: boolean;
};

function TextField({ autoFocus = false, autoScroll = false, ...props }: TextFieldT & TextFieldDST) {
  const scrollTimeOut = useRef<any>();
  const inputRef = useRef<any>();

  const [scrollToCenter, inputContainerRef] = useScroll('center');

  const onFocusTextField = () => {
    if (!navigator.userAgent.match(/iPhone|iPad/) && !!inputRef?.current) {
      scrollTimeOut.current = setTimeout(scrollToCenter, 300);
    }
  };

  useEffect(() => {
    inputRef.current = inputContainerRef?.current?.firstChild?.firstChild;

    autoScroll && inputRef.current?.addEventListener('focus', onFocusTextField);
    autoScroll && inputRef.current?.addEventListener('click', onFocusTextField);

    autoFocus && window.innerWidth > breakPointSm && inputRef.current?.focus();

    return () => {
      autoScroll && inputRef.current?.addEventListener('focus', onFocusTextField);
      autoScroll && inputRef.current?.addEventListener('click', onFocusTextField);

      clearTimeout(scrollTimeOut.current);
    };
  }, []);

  return (
    <div ref={inputContainerRef}>
      <TextFieldDS
        {...props}
        {...{
          autoComplete: 'nope',
        }}
      />
    </div>
  );
}

export default TextField;
